import apiClient, { unwrapData } from "./apiClient";

export async function getRoles(options = {}) {
  const response = await apiClient.get("/api/roles", options);
  return unwrapData(response);
}

export async function getTeamSummary(options = {}) {
  const response = await apiClient.get("/api/team/summary", options);
  return unwrapData(response);
}

export async function getTeamMembers(options = {}) {
  const response = await apiClient.get("/api/team/members", options);
  const data = unwrapData(response);
  return Array.isArray(data) ? data : data?.members || [];
}

export async function addTeamMember(payload = {}, options = {}) {
  const response = await apiClient.post("/api/team/members", {
    ...options,
    body: payload,
  });

  return unwrapData(response);
}

export async function rotateTeamMemberSchedule(id, options = {}) {
  const response = await apiClient.patch(`/api/team/members/${encodeURIComponent(id)}`, {
    ...options,
    body: {},
  });

  return unwrapData(response);
}

export async function updateTeamMember(id, payload = {}, options = {}) {
  const response = await apiClient.patch(`/api/team/members/${encodeURIComponent(id)}`, {
    ...options,
    body: payload,
  });

  return unwrapData(response);
}

export async function assignTeamCampaign(id, payload = {}, options = {}) {
  const response = await apiClient.post(
    `/api/team/members/${encodeURIComponent(id)}/assign-campaign`,
    {
      ...options,
      body: payload,
    },
  );

  return unwrapData(response);
}

export async function toggleTeamMemberStatus(id, nextStatus, options = {}) {
  const response = await apiClient.post(
    `/api/team/members/${encodeURIComponent(id)}/toggle-status`,
    {
      ...options,
      body: { status: nextStatus },
    },
  );

  return unwrapData(response);
}
